import React from 'react'
import Image from '../../../images/buyerpolicies/User Content.png'

const User_content = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>User Content</h2>
            <p>KAAY website includes user-generated content material that is taken from social media marketing applications. There is no requirement to follow any rules regarding that content which includes pictures, videos, images, etc. The content produced by users is not the responsibility of KAAY.</p>
        </div>
      </div>
    </div>
  )
}

export default User_content
